import axiosInstance from "../utils/axios";
import {
  IQuoteByFlightData,
  IQuoteBySurfaceTravelPrivateData,
  IQuoteBySurfaceTravelPublicData,
  IQuoteFixed
} from "../@interfaces/quote.interface";

const BASE_URL = "/estimates/v1";

async function createEstimateBySurfaceTravelPublic(data: IQuoteBySurfaceTravelPublicData, locale?: string) {
  return axiosInstance.post(`${BASE_URL}/surface/public`, data, {
    params: { locale }
  })
}

async function createEstimateBySurfaceTravelPrivate(data: IQuoteBySurfaceTravelPrivateData, locale?: string) {
  return axiosInstance.post(`${BASE_URL}/surface/private`, data, {
    params: { locale }
  })
}

async function createEstimateByFlight(data: IQuoteByFlightData, locale?: string) {
  return axiosInstance.post(`${BASE_URL}/flight`, data, {
    params: { locale }
  })
}

async function createEstimateFixed(data: IQuoteFixed) {
  return axiosInstance.post(`${BASE_URL}/fixed`, data)
}

export {
  createEstimateBySurfaceTravelPublic,
  createEstimateBySurfaceTravelPrivate,
  createEstimateByFlight,
  createEstimateFixed,
}